/**
 * jQuery UI Tabs Widget
 *
 * @see https://api.jqueryui.com/tabs/
 */
jQuery( function ( $ ) {
	$( '.ui-tabs' ).tabs( {
		activate: function ( e, i ) {
			// var hash = e.srcElement.hash.replace( '#', '' );
			var hash = i.newTab.context.hash.replace( '#', '' );

			$( '.ui-tab' ).hide();
			$( '.' + hash ).show();
		}
	} );

	// Hide all extra tabs on load except active.
	$( '.ui-tab' ).hide();

    $( '.open-tab' ).on( 'click', function ( e ) {
    	e.preventDefault();
        var tab = $( this ).attr( 'href' );
        $( '.ui-tabs' ).tabs( { active: 1 } );
        scroll( 0,0 );
    });
} );
